export default __webpack_public_path__ + "static/media/caf2b644-efc2-495e-af03-3b385d7de014.25cf1154.ttf";